import { render } from "./loginStatus.vue?vue&type=template&id=10ada502&scoped=true&ts=true"
import script from "./loginStatus.vue?vue&type=script&lang=ts"
export * from "./loginStatus.vue?vue&type=script&lang=ts"

import "./loginStatus.vue?vue&type=style&index=0&id=10ada502&lang=scss"
import "./loginStatus.vue?vue&type=style&index=1&id=10ada502&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_e1bdad7a4b23a28f51493789fcc92ed5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ada502"]])

export default __exports__